<div class="relative">
  @if (entityCount() > 1) {
    <button
      type="button"
      (click)="toggleDropdown($event)"
      [attr.aria-expanded]="dropdownOpen()"
      [class]="triggerButtonClass()">
      <span class="bn-entity-switcher__label truncate">{{
        displayLabel()
      }}</span>
    </button>

    @if (variant() === 'surface') {
      <svg
        class="bn-entity-switcher__caret pointer-events-none absolute right-5 top-1/2 z-10"
        [class.bn-entity-switcher__caret--open]="dropdownOpen()"
        width="12"
        height="7"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.296 7.709a1 1 0 001.416 0l6-6a1 1 0 00-1.416-1.416L7.002 5.587 1.709.296A1 1 0 00.293 1.712l6 6z"
          fill="#7D7E8B" />
      </svg>
    } @else {
      <img
        [src]="caretDownWhiteIconSrc"
        width="14"
        height="8"
        alt=""
        class="bn-entity-switcher__caret pointer-events-none absolute right-4 top-1/2 z-10 h-2 w-[14px] object-contain"
        [class.bn-entity-switcher__caret--open]="dropdownOpen()"
        aria-hidden="true" />
    }

    @if (dropdownOpen()) {
      <div
        class="bn-entity-switcher__menu absolute top-full left-0 mt-1 z-50 w-full rounded-[14px] border border-gray-200 bg-white shadow-lg">
        @if (authorities().length > 0) {
          <div
            class="px-4 pt-2 pb-1 text-[11px] font-bold uppercase tracking-wide text-slate-400">
            {{ 'navbar.authorities' | translate }}
          </div>
          @for (
            a of authorities();
            let i = $index;
            track i + '-' + (a.id ?? '')
          ) {
            <button
              type="button"
              (click)="selectEntity('authority:' + a.id)"
              class="bn-entity-switcher__menu-item"
              [class.bn-entity-switcher__menu-item--active]="
                selectedEntityValue() === 'authority:' + a.id
              ">
              {{ a.name }}
            </button>
          }
        }

        @if (schools().length > 0) {
          <div
            class="px-4 pt-2 pb-1 text-[11px] font-bold uppercase tracking-wide text-slate-400">
            {{ 'navbar.units' | translate }}
          </div>
          @for (
            school of schools();
            let i = $index;
            track i + '-' + (school.id ?? '')
          ) {
            <button
              type="button"
              (click)="selectEntity('school:' + school.id)"
              class="bn-entity-switcher__menu-item"
              [class.bn-entity-switcher__menu-item--active]="
                selectedEntityValue() === 'school:' + school.id
              ">
              {{ school.name }}
            </button>
          }
        }
      </div>
    }
  } @else {
    <div [class]="singleEntityClass()">
      <span class="bn-entity-switcher__single-label truncate">{{
        singleEntityName()
      }}</span>
    </div>
  }
</div>
